export default "__VITE_ASSET__BoxiNVWE__"